import { render } from "./voorkeuren-step.vue?vue&type=template&id=101c496a"
import script from "./voorkeuren-step.vue?vue&type=script&lang=js"
export * from "./voorkeuren-step.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__